import { render, staticRenderFns } from "./InvoiceItemsSummary.vue?vue&type=template&id=6ccd82b8&scoped=true&"
import script from "./InvoiceItemsSummary.vue?vue&type=script&lang=ts&"
export * from "./InvoiceItemsSummary.vue?vue&type=script&lang=ts&"
import style0 from "./InvoiceItemsSummary.vue?vue&type=style&index=0&id=6ccd82b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccd82b8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VDivider,VRow})
